<template>
  <span
    class="spinner inline-block shrink-0"
    :style="{ width: px, height: px, borderWidth: border }"
    role="status"
    :aria-label="ariaLabel"
  />
</template>

<script setup lang="ts">
import { computed } from "vue"

/**
 * The one loading spinner (wraps the global .spinner class). Use this
 * instead of re-sizing .spinner inline or hand-rolling animate-spin SVGs.
 */
const props = withDefaults(
  defineProps<{
    /** sm=16px (inline/buttons), md=32px (blocks), lg=48px (page-level) */
    size?: "sm" | "md" | "lg"
    ariaLabel?: string
  }>(),
  { size: "md" },
)

const px = computed(() => ({ sm: "16px", md: "32px", lg: "48px" })[props.size])
const border = computed(() => (props.size === "sm" ? "2px" : "3px"))
</script>
